import InputModal from "../../../components/modal/InputModal";
import SubformService from "../../../services/SubformService";
import { useTranslation } from "../../../state/i18n";
import type { VoidComponent } from "solid-js";
import type { Subform } from "../../../state/formVersion";
import { type InferOutput, object } from "valibot";
import { requireText } from "../../../utils/validation/base";
import { MAX_CHARACTERS_SM } from "../../../constants";
import { TextInput } from "../../../components/inputs/TextInput";

type SubformCreateModalProps = {
  onCreate: (subform: Subform) => void;
};
const SubformCreateModal: VoidComponent<SubformCreateModalProps> = (props) => {
  const { t } = useTranslation();
  const createSubformSchema = object({
    name: requireText(MAX_CHARACTERS_SM),
  });

  return (
    <InputModal<InferOutput<typeof createSubformSchema>>
      variant="default"
      title={t(($) => $.SUBFORMS_CREATE_MODAL_TITLE)}
      schema={createSubformSchema}
      confirmLabel={t(($) => $.SUBFORMS_CREATE_MODAL_ACTION_CONFIRM)}
      cancelLabel={t(($) => $.SUBFORMS_CREATE_MODAL_ACTION_CANCEL)}
      onConfirm={({ name }) => {
        const subform = SubformService.createSubform(name);
        props.onCreate(subform);
      }}
      initialValue={{ name: undefined }}
    >
      {({ value, updateValue, error }) => (
        <TextInput
          required
          label={t(($) => $.SUBFORMS_CREATE_MODAL_INPUT_NAME)}
          value={value("name")}
          onBlur={(e) => {
            updateValue("name", e.target.value);
          }}
          onInput={(e) => {
            updateValue("name", e.target.value);
          }}
          errorMessage={error("name")}
        />
      )}
    </InputModal>
  );
};

export default SubformCreateModal;
